module.exports = __webpack_public_path__ + "img/man-laptop.55c4e17a.png";